/**
 * 2019/1/9.
 * 作者:lzq
 *功能: 用户管理模块
 */
export default {
  $getway: 'sysapi',
  getUserList: 'user/list',
  getUserDetail: 'user/detail',
  saveUser: 'user/save',
  deleteUser: 'user/delete',
  saveUserComponent: 'UserComponent/save',
  getUserComponentDetail: 'UserComponent/detail',
  updateStateByPrimaryKey: 'user/open',
  getUserMenuList: 'authority/selectAuthorityByUserId',
  getUserByFunctionResource: 'authority/selectAuthorityByFunctionId'
};
